import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-jssi-card',
  templateUrl: './my-jssi-card.component.html',
  styleUrls: ['./my-jssi-card.component.scss']
})
export class MyJssiCardComponent implements OnInit {

  @Input() titleUp: string;
  @Input() titleDown: string;
  @Input() imageUrl: string;
  @Input() backgroundColor: string;
  @Input() content: string;
  @Input() onClickTriggered: any;

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/myJssi-card/my-jssi-card.component.ts